import {
  BookingChip,
  CancelButton,
  CancelIcon,
  ChipText,
  OrganiserBookingChip,
  OrganiserText
} from './group-booking-chip-styles'
import CloseCircle from './assets/close-circle.svg'

type GroupBookingChipProps = {
  userName?: string
  isOrganiser: boolean
  onCancel?: () => void
  deletable?: boolean
  assignable?: boolean
  onClick?: () => void
  selected?: boolean
}

const GroupBookingChip = ({
  userName,
  isOrganiser,
  onCancel,
  deletable,
  assignable,
  onClick,
  selected
}: GroupBookingChipProps) =>
  isOrganiser ? (
    <OrganiserBookingChip>
      <ChipText>{userName}</ChipText>
      <OrganiserText>{'\n'}Organiser</OrganiserText>
    </OrganiserBookingChip>
  ) : (
    <BookingChip
      deletable={deletable}
      onClick={onClick}
      selected={selected}
      assignable={assignable}
    >
      <ChipText aria-label={`chip-${userName}`}>{userName}</ChipText>
      {deletable && !assignable && (
        <CancelButton onClick={onCancel} data-testid={`remove-${userName}`}>
          <CancelIcon src={CloseCircle} alt={`remove-${userName}`} />
        </CancelButton>
      )}
    </BookingChip>
  )

export default GroupBookingChip
